import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import InstallPrompt from './components/feature/InstallPrompt';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <InstallPrompt />
    </BrowserRouter>
  );
}

export default App;
